module.exports = __webpack_public_path__ + "static/img/27.41eae9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/27.jpg
// module id = iEBO
// module chunks = 16